import { useEffect } from "react";
import { Link } from "react-router-dom";

interface SidebarMenuProps {
    isOpen: boolean;
    closeSidebar: () => void;
}

const SidebarMenu: React.FC<SidebarMenuProps> = ({ isOpen, closeSidebar }) => {


    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (!(event.target instanceof HTMLElement) || !event.target.closest('.sidebar-menu')) {
                closeSidebar();
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [isOpen, closeSidebar]);

    return (
        <div className={`sidebar-menu ${isOpen ? 'open' : ''}`}>
            <ul>
                <li>
                    <Link to="/" onClick={closeSidebar}>
                        <div className="gap-2">
                            <span>Notifications</span>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/" onClick={closeSidebar}>
                        <div className="gap-2">
                            <span>Support</span>
                        </div>
                    </Link>
                </li>
                <li>
                    <Link to="/profile" onClick={closeSidebar}>
                        <div className="gap-2">
                            <span>Profile</span>
                        </div>
                    </Link>
                </li>
            </ul>
        </div>
    );
};

export default SidebarMenu;
